import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import SortOrderList from '@jetshop/ui/SortOrder/SortOrderList';
import React from 'react';
import styled, { css } from 'react-emotion';
import { BooleanFilters } from './BooleanFilters';
import { ListAccordion } from './Mobile/ListAccordion';
import { RangeAccordion } from './Mobile/RangeAccordion';
import ActiveListFilters from '@jetshop/ui/Filter/ActiveFilters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Title = styled('h1')`
  text-align: center;
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 1rem;

  + div:first-of-type {
    border-top: 1px solid #dedede;
  }

  button {
    position: absolute;
    right: 17px;
    background: none;
    border: none;
  }
`;

const Wrapper = styled('div')`
  background: #fff;
  padding: 1rem;
  padding-bottom: 100px;

  svg {
    use {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
  button {
    padding: 0;
    border: 0;
    border-top: 1px solid #ddd;
    &:focus {
      outline: none;
      *:focus {
        outline: none;
      }
    }
    button {
      // FILTER BUTTON
      background: none;
      justify-content: flex-start;
      height: 30px;
      padding-left: 25px;
      font-size: 14px;
      background: #fff;
      border: 0;
      padding-right: 0;

      &:before {
        content: '';
        height: 15px;
        width: 15px;
        background: none;
        border: 1px solid black;
        margin-right: 10px;
      }

      svg {
        position: absolute;
        left: 28px;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        * {
          fill: black;
        }
      }

      &:last-child {
        margin-bottom: 10px;
      }
    }
  }

  label {
    padding: 0.7em 1em;
    padding-left: 0;
    height: 50px;
    border-top: 1px solid #dedede;

    span {
      height: 15px;
      width: 15px;
      border-radius: 100%;
    }
  }

  .handle {
    border-radius: 100%;
    background: ${({ theme }) => theme.colors.primary};
  }
  .slider {
    .bar-1:after {
      background: ${({ theme }) => theme.colors.primary};
    }
    + button {
      font-size: 12px;
      margin-top: 0.5rem;
      outline: none;
      text-align: center;
      text-transform: uppercase;
      transition: all ease 0.3s;
      width: 100%;
      letter-spacing: 2px;
      font-weight: bold;
      margin-bottom: 1rem;
      background: ${({ theme }) => theme.colors.primary};
      color: white;
    }
  }

  .close-button {
  }
`;

const boolFilters = css`
  padding: 1rem;
  label {
    margin-top: 0.5em;
  }
`;

const sortOrderListCss = css`
  border: 0;
  font-size: 16px;
  button {
    border: 0 !important;
    border-bottom: 1px solid #dedede !important;
    height: 42px;
    font-size: 14px;
  }
  section {
    border-top: 0;
  }
`;

const FilterBottom = styled('section')`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
  border-top: 1px solid #ddd;
  padding-top: 20vw;

  aside {
    width: auto;
    margin: 0;
    button {
      background: #a7a7a7;
      color: white;
    }
    div {
      display: none;
    }
  }
  button {
    width: auto;
    height: 40px;
    text-decoration: none;
    margin: 0;
    text-transform: none;
    letter-spacing: 0;
    font-size: 12px;
    background-image: none;
    padding: 0 1rem;
  }
  > button {
    width: auto;
    background: ${({ theme }) => theme.colors.primary};
    text-transform: none;
    letter-spacing: 0;
    color: white;
    font-weight: bold;
    font-size: 16px !important;
    width: 100%;
  }
`;

export default ({ filters, sortOrders, close, ...props }) => {
  const listFilters = (filters || []).filter(
    filter => filter.__typename === 'ListFilter'
  );

  return (
    <section {...props}>
      {filters ? (
        <Wrapper>
          <Title>
            {t('Filter')}
            <button onClick={close}>
              <FontAwesomeIcon icon={['fal', 'times']} />
            </button>
          </Title>

          <Accordion single>
            {accordionProps => (
              <React.Fragment>
                <ListAccordion
                  filters={filters}
                  accordionProps={accordionProps}
                />
                <RangeAccordion
                  filters={filters}
                  accordionProps={accordionProps}
                  startingIdx={listFilters.length}
                />

                <BooleanFilters filters={filters} />

                <FilterBottom>
                  <button onClick={close}>{t('Show results')}</button>
                  <ActiveListFilters filters={filters} />
                </FilterBottom>
              </React.Fragment>
            )}
          </Accordion>
        </Wrapper>
      ) : (
        <Wrapper>
          <Title>
            {t('Sort by')}
            <button onClick={close}>
              <FontAwesomeIcon icon={['fal', 'times']} />
            </button>
          </Title>
          <div className={sortOrderListCss}>
            <SortOrderList sortOrders={sortOrders} />
            <FilterBottom>
              <button onClick={close}>{t('Show results')}</button>
            </FilterBottom>
          </div>
        </Wrapper>
      )}
    </section>
  );
};
